import { DEFAULT_CUSTOM_CLAIM_CLIENT, getCustomClaimClientsError } from '../../utils/customClaimClients';

const REQUIRED_SAML_PROVIDER_NAME_MESSAGE = 'SAML provider name is required.';

export type SSOSaveDecision =
  | { kind: 'noop' }
  | { kind: 'invalid'; message: string }
  | { kind: 'save' };

function haveSameMembers(first: string[], second: string[]): boolean {
  return first.length === second.length && first.every((value) => second.includes(value));
}

export function resolveSSOSaveDecision({
  hasExistingSSOConfig,
  newMetadataUrl,
  newXmlMetadata,
  newSamlProviderName,
  originalCustomClaimClients,
  newCustomClaimClients,
}: Readonly<{
  hasExistingSSOConfig: boolean;
  // Only set when it differs from the stored metadata URL
  newMetadataUrl: string | null;
  newXmlMetadata: string | null;
  newSamlProviderName: string;
  originalCustomClaimClients: string[];
  newCustomClaimClients: string[];
}>): SSOSaveDecision {
  const customClaimClientsError = getCustomClaimClientsError(newCustomClaimClients);
  if (customClaimClientsError) {
    return { kind: 'invalid', message: customClaimClientsError };
  }

  const hasNewMetadata = newMetadataUrl !== null || newXmlMetadata !== null;

  if (hasExistingSSOConfig) {
    const unchanged = !hasNewMetadata && haveSameMembers(originalCustomClaimClients, newCustomClaimClients);
    return unchanged ? { kind: 'noop' } : { kind: 'save' };
  }

  const hasCustomClaimClients = newCustomClaimClients.some((client) => client !== DEFAULT_CUSTOM_CLAIM_CLIENT);
  if (!newSamlProviderName && !hasNewMetadata && !hasCustomClaimClients) {
    return { kind: 'noop' };
  }
  if (!newSamlProviderName) {
    return { kind: 'invalid', message: REQUIRED_SAML_PROVIDER_NAME_MESSAGE };
  }

  return { kind: 'save' };
}
